export interface IMenuState {
  showOverview: boolean;
  menuOpen: boolean;
  anchorEl: HTMLElement | null;
  menuSelectedPage: string | null;
}

export const DEFAULT_VIEW = 'Default';
export const SAAS_TENANTS_VIEW = 'SaaSTenants';
export const ANALYTICS_VIEW = 'Analytics';
export const BILLING_VIEW = 'Billing';
export const CONTROL_VIEW = 'Control';
export const DOCUMENTS_MANAGER_VIEW = 'DocumentsManager';
